// Общие блоки ИИ: Markdown ответа, строка «Это не медицинская рекомендация», «ИИ не настроен».

import { Fragment } from 'react'
import { Link } from 'react-router-dom'

import { Icon } from '@/components/ui'
import { cn } from '@/lib/cn'

import { parseMarkdown, type Inline } from './markdown'

export const DISCLAIMER = 'Это не медицинская рекомендация'
export const NOT_CONFIGURED = 'ИИ не настроен'

function InlineText({ parts }: { parts: Inline[] }) {
  return (
    <>
      {parts.map((p, i) =>
        p.bold ? (
          <strong key={i} className="font-semibold text-fg">
            {p.text}
          </strong>
        ) : p.italic ? (
          <em key={i}>{p.text}</em>
        ) : p.code ? (
          <code key={i} className="rounded bg-surface-2 px-1 font-mono text-[0.9em]">
            {p.text}
          </code>
        ) : (
          <Fragment key={i}>{p.text}</Fragment>
        ),
      )}
    </>
  )
}

/** Ответ модели в Markdown — без HTML, только текст и простая разметка. */
export function Markdown({ text, className }: { text: string; className?: string }) {
  const blocks = parseMarkdown(text)
  return (
    <div className={cn('grid gap-2 text-sm leading-relaxed text-fg', className)}>
      {blocks.map((block, i) => {
        if (block.type === 'heading') {
          return (
            <h3 key={i} className={cn('font-semibold text-fg', block.level <= 2 ? 'text-base' : 'text-sm', i > 0 && 'mt-2')}>
              <InlineText parts={block.content} />
            </h3>
          )
        }
        if (block.type === 'list') {
          const Tag = block.ordered ? 'ol' : 'ul'
          return (
            <Tag key={i} className={cn('grid gap-1 pl-5', block.ordered ? 'list-decimal' : 'list-disc')}>
              {block.items.map((item, j) => (
                <li key={j}>
                  <InlineText parts={item} />
                </li>
              ))}
            </Tag>
          )
        }
        return (
          <p key={i}>
            {block.lines.map((line, j) => (
              <Fragment key={j}>
                {j > 0 ? <br /> : null}
                <InlineText parts={line} />
              </Fragment>
            ))}
          </p>
        )
      })}
    </div>
  )
}

export function Disclaimer({ className }: { className?: string }) {
  return <p className={cn('text-xs text-muted', className)}>{DISCLAIMER}</p>
}

/** «ИИ не настроен — задай LLM_* в .env» со ссылкой на настройки ИИ. */
export function NotConfigured({ className }: { className?: string }) {
  return (
    <div className={cn('flex items-start gap-2 text-sm text-muted', className)}>
      <Icon name="info" size={18} className="mt-px shrink-0" />
      <p>
        <strong className="font-medium text-fg">{NOT_CONFIGURED}</strong> — задай LLM_* в .env.{' '}
        <Link to="/settings/ai" className="text-accent underline-offset-2 hover:underline">
          Настройки ИИ
        </Link>
      </p>
    </div>
  )
}
